import { takeLatest, call, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { Modal } from 'antd';
import moment from 'moment';
import axios from 'axios';

// import { API_BASE_URL, REACT_APP_API_HEADER_SECURITY } from '../../config';
import * as types from './Constant';
import * as actions from './Actions';

/* ================= WATCHER ================= */

export function* doctorCampaignWatcher() {
    yield takeLatest(types.PATIENT_DETAILS_GET, patientDetails);
    yield takeLatest(types.GET_SLOTS_DOC, timeslotsGet);
    yield takeLatest(types.DOC_DETAILS_GET_CAMPAIGN, doctorDetails);
    yield takeLatest(types.DEPARTMENT_DOC_LISTING, departmentListingDoctors);
    yield takeLatest(types.UPDATE_SCHEDULE_DATA_SLOT, updateConsultaionShedule);
}

/* ================= WORKERS ===== ============ */

function* patientDetails() {
    try {
        const id = localStorage.getItem('PATIENT_IDS');
        const url = `${process.env.REACT_APP_API_BASE_URL}/familydetails?parentId=${id}`;

        const headers = {
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const response = yield call(axios.get, url, { headers });

        if (response.status === 200) {
            yield put(actions.getPatientDetailsSuccess(response.data));
        }
    } catch (err) {
        if (err.response?.status === 401) {
            Modal.warning({ title: 'Please login and try again' });
            yield put(push('/login'));
        }
        yield put(actions.campaignFailed());
    }
}


function* doctorDetails() {
    try {
        const id = localStorage.getItem('DOC_CAMPAIGN_ID');
        const firstname = localStorage.getItem('DOC_CAMPAIGN_NAME_FIRST');
        const lastname = localStorage.getItem('DOC_CAMPAIGN_NAME_LAST');
        const department = localStorage.getItem('DOC_CAMPAIGN_DEPARTMENT');

        const convertedDepartment = department
            ? department.split('-').join('%20')
            : null;

        let url = `${process.env.REACT_APP_API_BASE_URL}/doctordetails?doctorsId=${id}`;

        if (firstname && lastname) {
            url += `&firstName=${firstname}&lastName=${lastname}`;
        }
        if (convertedDepartment) {
            url += `&specialization=${convertedDepartment}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
            
        };

        const response = yield call(axios.get, url, { headers });

        if (response.status === 200) {
            localStorage.setItem('ORG_ID_DOC', response.data.organisationsId);
            localStorage.setItem('ORG_ID', response.data.organisationsId);

            yield put(actions.getDoctorDetailsSuccess(response.data));
        }
    } catch (err) {
        yield put(actions.campaignFailed());
    }
}


function* timeslotsGet() {
    try {
        const docId = localStorage.getItem('DOC_CAMPAIGN_ID');
        const startDate = moment().format('YYYY-MM-DD');
        const endDate = moment().add(7, 'days').format('YYYY-MM-DD');

        const url = `${process.env.REACT_APP_API_BASE_URL}/schedules?doctorsId=${docId}&consultationTypeId=3&date[$gte]=${startDate}&date[$lte]=${endDate}&$sort[date]=1&$sort[time]=1&$limit=1000&isVacant=true`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const response = yield call(axios.get, url, { headers });

        if (response.status === 200) {
            yield put(actions.getDoctorSlotsSuccess(response.data.data));
        }
    } catch (err) {
        if (err.response?.status === 401) {
            Modal.warning({ title: 'Please login and try again' });
            yield put(push('/login'));
        }
        yield put(actions.campaignFailed());
    }
}


function* departmentListingDoctors() {
    try {
        const department = localStorage.getItem('DEPARTMENT_LISTING_DOC');
        const convertedDepartment = department
            ? department.split('-').join('%20')
            : '';

        const page = Number(localStorage.getItem('PAGE_DEPARTMENT_LISTING')) || 1;
        const skip = (page - 1) * 10;

        const url = `${process.env.REACT_APP_API_BASE_URL}/doctordepartments?specialization=${convertedDepartment}&limit=10&skip=${skip}`;

        const headers = {
            'Content-Type': 'application/json',
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const response = yield call(axios.get, url, { headers });

        if (response.status === 200) {
            yield put(actions.getDepartmentDoctorsSuccess(response.data));
        } else {
            yield put(actions.getDepartmentDoctorsSuccess([]));
        }
    } catch (err) {
        yield put(actions.campaignFailed());
    }
}

function* updateConsultaionShedule(action) {

    try {
        
        
        const consulationId = action.payload.consultationTypeId;
        const orgFeeId = action.payload.orgFeesId;
        const slotId = action.payload.slotId;
        const url1 = `${process.env.REACT_APP_API_BASE_URL}/schedules/${slotId}`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'Content-Type': 'application/json',
            Authorization: sessionStorage.jwt,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };

        const data = {
            orgFeesId: orgFeeId,
            consultationTypeId: consulationId,
        };
        
        const response1 = yield call(axios.patch, url1, data, { headers });

        // // Check if the response is successful
        if (response1.status === 200 || response1.status === 201) {


            const url2 = `${process.env.REACT_APP_API_BASE_URL}/schedules?id=${response1.data.id}`;

            const response2 = yield call(axios.get, url2, { headers });

            if(response2.status === 200 || response2.status === 201) {
                yield put(actions.updateScheduleSlotRequestSuccess(response2.data));               
            }  
        } else {
            // Dispatch the failure action with the response message
            yield put(actions.updateScheduleSlotRequestError('An error occurred.'));
        }

    } catch (error) {

        // yield put(passportRequestError('An error occurred.'));
        // throw error;
        // yield put(fetchUserFailure(error));
    }
}